import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import PendingPaymentsList from '../components/payments/PendingPaymentsList';

const PendingPaymentsPage = () => {
  return (
    <Box sx={{ p: 3 }}>
      <Paper sx={{ p: 2 }}>
        <Typography variant="h5" sx={{ mb: 2 }}>Pending Payments</Typography>
        <PendingPaymentsList />
      </Paper>
    </Box>
  );
};

export default PendingPaymentsPage;
